import React from 'react';
import { BonusesSection, Closing, FAQSection, Guarantee, Pain, ProductOverview, ResultsAndGuarantee, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white text-ink/70 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2mmce69087cca">
      <MetaPixel data-id="element-1" data-mp="31bs0ncsq4vm6" />
      <TopBar data-id="element-2" data-mp="31c9tdzg6grpc" />
      <main data-id="element-3" data-mp="31ctdnmtavs6j">
        <Hero data-id="element-4" data-mp="31cjpm4rtfv3h" />
        <Testimonials data-id="element-5" data-mp="2wk9zooqpav17" />
        <Pain data-id="element-6" data-mp="2wjqkvgwckmre" />
        <ProductOverview data-id="element-7" data-mp="2wj8f9tnsow6t" />
        <BonusesSection data-id="element-8" data-mp="2whxb3sqftmf6" />
        <Pricing data-id="element-9" data-mp="28u5yeo0zj7dd" />
        <Guarantee data-id="element-10" data-mp="28tmfb3zlmcxr" />
        <ResultsAndGuarantee data-id="element-11" data-mp="28t4lsf4bmctj" />
        <FAQSection data-id="element-12" data-mp="28sb9kymlev40" />
        <Closing data-id="element-13" data-mp="23vcm2yxfpmes" />
      </main>
      <Footer data-id="element-14" data-mp="23u9t8lgjx9w8" />
      <FloatingElements data-id="element-15" data-mp="23ujl6el5pr4k" />
      <noscript data-id="element-16" data-mp="23t8fuac2cbbc">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-17" data-mp="3ijxqiu0iq6lh" />
      </noscript>
    </div>;
}